<template>
  <div class="mainNew">
    <div class="topTitle">
      <span>培训中心</span> / 培训课程
    </div>
    <div class="class-management">
      <el-form size="mini" :inline="true" ref="ruleForm" :model="ruleForm">
        <el-form-item label="所属科目" v-show="moresearch">
          <el-radio-group v-model="ruleForm.subjectIds" @change="search">
            <el-radio v-for="item of subjectList" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item label="培训类型" v-show="moresearch">
          <el-radio-group v-model="ruleForm.videoTypeId" @change="getVideoList">
            <el-radio label="">全部</el-radio>
            <el-radio v-for="item of videotagList" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <br />
        <el-form-item v-show="moresearch" label="所属课程" prop="curriculumIds">
          <el-select v-model="ruleForm.curriculumIds" placeholder="请选择" clearable collapse-tags multiple @change="getVideoList">
            <el-option :label="item.title" :value="item.id" v-for="(item, index) of curriculum_list" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="section">
        <div class="subject">
          <el-row :gutter="20">
            <el-col :span="6" v-for="item of videoList" :key="item.id">
              <div class="courses">
                <div class="courses_img">
                  <el-image class="coursesimg" :src="item.cover_url" fit="fill"></el-image>
                </div>
                <div class="courses_title">{{ item.title }}</div>
                <div class="courses_date">
                  <el-link @click="LearnVideo(item)">开始学习<i class="el-icon-video-play"></i>
                  </el-link>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="pagination-style">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page_no" :page-sizes="[10, 15, 20, 30, 40, 50, 100]" :page-size="page_size" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>

      <el-dialog title="培训课程" :visible.sync="dialogVisible" width="840px" top="10vh" append-to-body>
        <el-row style="text-align: center">
          <el-col :span="24">
            <div class="course-right-video-desc">
              <video style="width: 800px" class="coursevideo" :src="training_videourl" controls="controls" :poster="training_poster">
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import {
  getClassesList,
  getEducationalInstitutionCampusList,
  getNotDivideStudentList,
  addStudentClassRelation,
  getClassStudentList,
  delStudentClassRelation,
  getUserCampusList,
  getCampusSubjectList,
  getCampusCurriculumtList,
  updateClasses,
  getPrepareCurrculumList,
  getPrepareCurrculumMaterialList,
  getVideoList,
  getVideoTypeList,
} from "@/api/educational";

export default {
  name: "training-course",

  data() {
    return {
      pagename: "class-management",

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },

      //分页管理
      //班级列表分页
      page_no: 1,
      page_size: 20,
      total: 0,

      //班级学员分页
      page_no1: 1,
      page_size1: 20,
      total1: 0,
      //已报课学员分页
      page_no2: 1,
      page_size2: 20,
      total2: 0,

      teacherListTo: "",

      moresearch: true,
      curriculum_title: "",
      dialogVisible: false,

      training_videourl: "",
      training_poster: "",

      input1: "",
      input2: "",
      input3: "",
      select: "",

      tableData1: [], //班级学员列表
      tableData2: [], //未分班学员列表

      dialogTableVisible: false,
      dialogFormVisible: false,
      dialogFormVisible7: false, //修改班级信息

      schoolList: [], //学校信息
      subjectList: [], //科目列表
      curriculum_list: [], //体系列表
      teacherList: [], //教师列表
      rules: {
        curriculum_id: [
          {
            required: true,
            message: "请选择课程",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入班级名称",
            trigger: "blur",
          },
        ],
        teaching_type: [
          { required: true, message: "请选择课程类型", trigger: "change" },
        ],
        lecturer_id: [
          { required: true, message: "请选择主讲老师", trigger: "change" },
        ],
        educational_institution_campus_id: [
          { required: true, message: "请选择校区", trigger: "change" },
        ],
        sort_num: [
          { required: true, message: "请输入排序号", trigger: "change" },
        ],
        subject_id: [
          { required: true, message: "请选择学科", trigger: "change" },
        ],
      },
      //正式学员续班
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },

      formLabelWidth: "120px",
      //搜索正式班级
      ruleForm: {
        videoTypeId: "",
        search_type: "",
        lecturer_id: "",
        classname: "",
        search_value: "",
        subjectIds: "",
        curriculumIds: [],
        teaching_type: "",
        class_start_time: "",
        class_end_time: "",
        course_type: "",
        course_state: [],
        educational_institution_campus_id: "", //所属校区
        startdate: [], //开班日期
        enddate: [], //结课日期
      },
      //更新班级信息
      updateform: {
        id: "",
        educational_institution_campus_id: "",
        teaching_type: "",
        curriculum_id: "",
        lecturer_id: "",
        assistant_teacher_id: "",
        name: "",
      },

      classStartTime: "",

      tableData: [],
      //学员续班

      haschoose_teachplan: false,

      //转为正式学员
      haschoose_class: false,
      order_state: "", //学员转公开课试听
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false, //跟班试听学员转为正式
      //公开课试听学员
      form1: {
        nickname: "",
        student_user_id: "", //学生ID
        curriculum_class_id: "", //班级ID
        other_goods_list: [], //其他商品列表
        remark: "", //备注
        chooseClassinfo: {},
        chooseGoods: [],
      },
      //退费订单
      form2: {
        original_curriculum_class_price: 0,
        otherGoodsArr: [],
        refund_type: "1",
        remark: "",
      },

      Goodslist: [],
      goodslist: [],

      haschoose_student: false,
      chooseStudentInfo: {},

      outerVisible: false,
      outerVisible1: false,
      curriculum_class_price: "", //班级商品实收价格

      haschoose_good: false, //是否选择了商品

      chooseTeachPlanList: [],
      haschoose_plan: false,
      teaching_plan_list: [],

      total_price: 0,
      total_outprice: 0,
      Audition_StudentData: [],
      Audition_GoodsData: [],

      ClassStudentManagermentData: [], //班级里的试听学员
      ClassOpenStudentManagermentData: [], //跟班试听学员列表
      ClassStudentManagerment: {}, //当前选择的班级
      chooseAuditionClassList: {}, //试听班级信息

      originalCurriculumMeterialList: [], //出勤讲次
      originalCurriculum: {}, //学员报名的课程体系
      originalOrderInfo: {}, //学员退费订单详情
      originalotherGoodsArr: [],
      originalOrder: {}, //

      insign_num: 0,
      sign_num: 0,
      goodprice: 0,

      activeName: "first", //正式学员列表

      curriculum_class_type: "", //班级查询类型  1 正式课程  2试听课程
      NoClassStudents: [], // 未分班学员
      OutClassStudents: [], //即将移除班级的学员
      CurrentSelectClassId: {}, //当前选择的班级
      studentIds: [], //选中的学员ID
      outstudentIds: [], //选中即将移除班级的学员
      current_class_id: "",

      curriculumMaterialList: [],

      hasauth: false,
      course_form: {
        subject_id: "",
        teaching_type: "",
        course_type: "",
      },

      videoList: [], //培训视频列表
      videotagList: [], //视频分类列表
    };
  },

  watch: {
    "$store.state.user.selected_schools": {
      handler(newValue) {
        console.log("校区监听");

        if (newValue.length == 0) {
          this.$message.warning("请选择校区");
          this.subjectList = [];
          this.curriculum_list = [];
          this.curriculum_id = "";
          this.ruleForm.subject_id = "";
        } else {
          this.getCampusSubjectList();
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning("请选择校区");
    } else {
      this.getCampusSubjectList();
    }
    this.getEducationalInstitutionCampusList(); //获取分校列表
    this.getVideoTypeList();
  },
  methods: {
    getVideoTypeList() {
      getVideoTypeList().then((res) => {
        console.log("查询视频分类列表");
        console.log(res);
        this.videotagList = res.videoList;
      });
    },

    getPrepareCurrculumList() {
      getPrepareCurrculumList({
        subject_id: this.course_form.subject_id,
        teaching_type: this.course_form.teaching_type,
        course_type: this.course_form.course_type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.subjectList = res.subjectList;
        this.curriculumList = res.curriculumList;

        console.log("备授课课程返回");
        console.log(this.curriculumList);
        console.log(this.subjectList);
      });
    },

    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch;
    },

    search() {
      this.page_no = 1;
      this.getVideoList();
      this.getCampusCurriculumtList();
    },

    getEducationalInstitutionCampusList() {
      getEducationalInstitutionCampusList().then((res) => {
        console.log("获得分校列表");
        console.log(res);
        this.school_list = res.educational_institution_campus_list;
      });
    },

    //获取学校公开课课程体系
    getCampusCurriculumtList() {
      console.log("查询课程体系");
      this.curriculum_list = [];
      this.ruleForm.curriculumIds = [];

      if (this.ruleForm.subjectIds) {
        for (
          let j = 0;
          j < this.$store.state.user.selected_schools.length;
          j++
        ) {
          getCampusCurriculumtList({
            campusId: this.$store.state.user.selected_schools[j],
            subjectId: this.ruleForm.subjectIds,
            teaching_type: this.ruleForm.teaching_type,
            class_type: "",
          }).then((res) => {
            console.log("获取学校科目下全部课程");
            console.log(res);

            for (let i = 0; i < res.campusCurriculumList.length; i++) {
              this.curriculum_list.push(res.campusCurriculumList[i]);
              this.curriculum_list = this.unique(this.curriculum_list);
            }
          });
        }
      }
    },

    // 获取班级列表
    getClassesList() {
      console.log("this.ruleForm.value1");
      console.log(this.ruleForm.value1);

      getClassesList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        curriculum_class_type: this.ruleForm.course_state,
        className: this.ruleForm.classname,
        lecturer_id: this.ruleForm.lecturer_id,
        subject_id: this.ruleForm.subject_id,
        curriculum_id: this.ruleForm.curriculum_id,
        teaching_type: this.ruleForm.teaching_type,
        class_start_time_begin: this.ruleForm.startdate
          ? this.ruleForm.startdate[0]
          : null,
        class_start_time_end: this.ruleForm.startdate
          ? this.ruleForm.startdate[1]
          : null,

        class_end_time_begin: this.ruleForm.enddate
          ? this.ruleForm.enddate[0]
          : null,
        class_end_time_end: this.ruleForm.enddate
          ? this.ruleForm.enddate[1]
          : null,

        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.tableData = res.class_list;
        //this.total = res.total;

        console.log("查询班级列表");
        console.log(res);
      });
    },

    //更新班级信息
    updateClasses() {
      console.log("更新班级参数");
      console.log(this.updateform);
      updateClasses({
        classId: this.updateform.id,
        name: this.updateform.name,
        subject_id: this.updateform.subject_id,
        curriculum_id: this.updateform.curriculum_id,
        educational_institution_campus_id:
          this.updateform.educational_institution_campus_id,
        teaching_type: this.updateform.teaching_type,
        lecturer_id: this.updateform.lecturer_id,
        assistant_teacher_id: this.updateform.assistant_teacher_id,
      }).then((res) => {
        console.log("更新班级");
        console.log(res);
        if (res.is_update) {
          this.$message.success("修改成功");
          this.dialogFormVisible7 = false;
          this.getClassesList();
        }
      });
    },

    reSize(formName) {
      this.classStartTime = "";
      this.search_type = "";
      this.ruleForm.search_value = "";
      this.$refs[formName].resetFields();
      this.getClassesList();
    },

    lookClasses(row) {
      this.$router.push({
        name: "look-class-info",
        query: {
          class_code: row.class_code,
        },
      });
    },

    courseArranging(row) {
      console.log("班级排课");
      console.log(row);

      if (row.curriculum_class_type == "1") {
        this.$router.push({
          name: "course-arranging",
          query: {
            class_code: row.class_code,
            id: row.id,
          },
        });
      } else {
        this.$router.push({
          name: "open-course-arranging",
          query: {
            class_code: row.class_code,
            id: row.id,
          },
        });
      }
    },

    //点击分班按钮
    DivideStudent(row) {
      console.log("需要分班的班级");
      console.log(row);
      this.CurrentSelectClassId = row.id;
      this.dialogFormVisible2 = true;

      this.getNotDivideStudentList();
      this.getClassStudentList(); //查询班级学员列表
    },

    //已报名未分班学员
    getNotDivideStudentList() {
      getNotDivideStudentList({
        classId: this.CurrentSelectClassId,
        realname: "",
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log("查询已报名未分班学员");
        console.log(res);
        this.tableData2 = res.studentList;
        this.total2 = res.total;
      });
    },

    getClassStudentList() {
      getClassStudentList({
        classId: this.CurrentSelectClassId,
        realname: "",
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log("查询班级学员列表");
        console.log(res);
        this.tableData1 = res.studentList;
        this.total1 = res.total;
      });
    },

    //添加学员进班
    addStudentClassRelation() {
      this.studentIds = []; //清空学生ID组

      for (let k = 0; k < this.NoClassStudents.length; k++) {
        this.studentIds.push(this.NoClassStudents[k].id);
      }

      console.log("添加学员参数");
      console.log(this.studentIds);
      console.log("班级ID");
      console.log(this.CurrentSelectClassId);

      addStudentClassRelation({
        studentIds: JSON.stringify(this.studentIds),
        curriculum_class_id: this.CurrentSelectClassId,
        in_class_date: "2021-4-19",
      }).then((res) => {
        console.log("添加学员进班");
        console.log(res);
        if (res.is_create) {
          this.$message.success("入班成功");
          this.getClassStudentList();
          this.getNotDivideStudentList(this.CurrentSelectClassId);
        }
      });
    },

    //班级移除学员
    delStudentClassRelation() {
      this.outstudentIds = []; //清空学生ID组

      for (let k = 0; k < this.OutClassStudents.length; k++) {
        this.outstudentIds.push(this.OutClassStudents[k].studentInfo.id);
      }

      console.log("移除学员参数");
      console.log(this.outstudentIds);
      console.log("班级ID");
      console.log(this.CurrentSelectClassId);

      delStudentClassRelation({
        studentIds: JSON.stringify(this.outstudentIds),
        curriculum_class_id: this.CurrentSelectClassId,
      }).then((res) => {
        console.log("班级移除学员");
        console.log(res);
        if (res.is_delete) {
          this.$message.success("移除成功");
          this.getClassStudentList();
          this.getNotDivideStudentList(this.CurrentSelectClassId);
        }
      });
    },

    handleSelectionNoClassStudent(selection) {
      this.NoClassStudents = selection;
      console.log("已选未分班学员");
      console.log(this.NoClassStudents);
    },
    //移除班级的学员
    handleSelectionOutClassStudent(selection) {
      this.OutClassStudents = selection;
      console.log("已选即将移除班级的学员");
      console.log(this.OutClassStudents);
    },

    editClasses(row) {
      this.$router.push({
        name: "create-class",
        query: {
          class_code: row.class_code,
        },
      });
    },
    // 单个建班
    singleCreateClass(cmd) {
      if (cmd == "1") {
        console.log("新增试听班");
        this.$router.push({
          name: "create-openclass",
        });
      } else {
        console.log("新增正式班");
        this.$router.push({
          name: "create-class",
        });
      }
    },

    chooseClass(val) {
      console.log("子组件传值");
      console.log(val);
      this.form1.chooseClassinfo = val;
      this.curriculum_class_price = val.goods_price;
      this.haschoose_class = true;
    },

    changeClass(row) {
      console.log("正式学员调班");
      console.log(row);
      this.dialogFormVisible = true;
      this.form1.nickname = row.nickname;
      this.form1.student_user_id = row.id;
      this.order_state = "5";
    },

    chooseStudent(val) {
      console.log("子组件传值-已选学员");
      console.log(val);
      this.haschoose_student = true;
      this.chooseStudentInfo = val;
    },

    chooseTeachPlan(val) {
      console.log("子组件传值-教学计划列表");
      console.log(val);
      this.chooseTeachPlanList = [];
      this.chooseTeachPlanList = val;
      this.haschoose_plan = true;
      console.log(this.chooseTeachPlanList);
      this.chooseTeachPlanList.forEach((item, index) => {
        console.log(index);
        const plan_list = {
          id: item.id,
        };
        //价格
        this.teaching_plan_list.push(plan_list);
      });
      console.log("教学计划ID列表");
      console.log(this.teaching_plan_list);
    },

    //TODO UpateClassInfo
    UpateClassInfo(row) {
      console.log("更新班级信息");
      console.log(row);
      this.dialogFormVisible7 = true;
      this.updateform.id = row.id;
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id;
      this.updateform.teaching_type = row.teaching_type;
      this.updateform.curriculum_id = row.curriculum_id;
      this.updateform.lecturer_id = row.lecturer_id;
      this.updateform.assistant_teacher_id = row.assistant_teacher_id;
      this.updateform.name = row.name;
      this.updateform.subject_id = row.subject_id;
      this.updateform.start_date = row.start_date;

      this.updateform.curriculum_class_type = row.curriculum_class_type;

      this.getUserCampusList();
      this.getCampusSubjectList();
      this.getCampusCurriculumtList();
    },

    // 获取校区
    getUserCampusList() {
      getUserCampusList().then((res) => {
        this.schoolList = res.userDeptList;
      });
    },

    //获取学校科目权限列表
    getCampusSubjectList() {
      this.subjectList = [];
      for (let k = 0; k < this.$store.state.user.selected_schools.length; k++) {
        getCampusSubjectList({
          campusId: this.$store.state.user.selected_schools[k],
        }).then((res) => {
          for (let j = 0; j < res.campusSubjectList.length; j++) {
            this.subjectList.push(res.campusSubjectList[j]);
            this.subjectList = this.unique(this.subjectList);
          }

          this.ruleForm.subjectIds = this.subjectList[0].id;

          this.getVideoList();
          this.getCampusCurriculumtList();
        });
      }
    },

    //数组对象去重
    unique(arr) {
      const res = new Map();
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1));
    },

    handleClickCard(item) {
      console.log(item);

      getPrepareCurrculumMaterialList({
        curriculum_id: item.id,
      }).then((res) => {
        this.curriculumMaterialList = res.curriculumMaterialList;
        this.dialogVisible = true;
        this.curriculum_title = item.title;
        console.log(res);
      });
    },

    LearnVideo(row) {
      console.log("开始学习");
      //this.dialogVisible = true;
      //this.training_videourl = row.url;
      //this.training_poster = row.cover_url;

      this.$router.push({
        name: "traininglist",
        query: {
          title: row.title,
        },
        params: {
          videolist: row.videoSingleArr,
        },
      });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.page_size = val;
      this.getVideoList();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.getVideoList();
    },

    tableRowClassName({ row }) {
      if (row.start_date == null) {
        return "warning-row";
      }
      return "";
    },

    //查询培训视频类表
    getVideoList() {
      const roleIds = [];
      for (let k = 0; k < this.$store.state.user.roleList.length; k++) {
        roleIds.push(this.$store.state.user.roleList[k].id);
      }

      if (!this.ruleForm.subjectIds) {
        this.ruleForm.curriculumIds = [];
      }

      console.log("物料查询");
      console.log(this.ruleForm);

      getVideoList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        title: this.ruleForm.title,
        teaching_type: this.ruleForm.teaching_type,
        subjectIds: this.ruleForm.subjectIds
          ? JSON.stringify([this.ruleForm.subjectIds])
          : JSON.stringify([]),
        curriculumIds: JSON.stringify(this.ruleForm.curriculumIds),
        roleIds: JSON.stringify(roleIds),
        videoTypeId: this.ruleForm.videoTypeId,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("查看培训视频列表");
        console.log(res);
        this.videoList = res.videoList;
        this.total = res.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mainNew {
  height: 100%;
  // overflow: auto;
}
.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.class-management {
  min-height: calc(100% - 30px);
  margin: 10px;
  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  background-color: #fff;

  .subject {
    .courses {
      border: 1px solid rgb(236, 236, 236);

      display: flex;
      flex-flow: column;
      margin-bottom: 20px;
      border-radius: 5px;
      background: #f7f8fa;
      .courses_img {
        height: 0;
        padding-bottom: 45.33%;

        .coursesimg {
          width: 100%;
          border-radius: 5px;
        }
      }
      .courses_title {
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        margin-top: 8%;
      }
      .courses_date {
        text-align: center;
        line-height: 20px;
        padding-bottom: 10px;
      }
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .setting {
    float: right;
  }
  .table-style {
    margin-top: 20px;
  }
}
</style>

<style>
.class-management .el-divider--horizontal {
  margin-bottom: 20px;
  margin-top: 5px;
}

.class-management .el-table .warning-row {
  background: oldlace;
}

.class-management .el-table .success-row {
  background: #f0f9eb;
}
</style>
 